/* eslint-disable jsx-a11y/alt-text */
import React, { Component, Fragment } from "react";
import { shopContext } from "../../contexts/aniplus";
import { withRouter } from "react-router-dom";
import { isMobile } from "react-device-detect";
import axios from "axios";
import { confirmAlert } from "react-confirm-alert"; //알럿창(alert confirm)
import "react-confirm-alert/src/react-confirm-alert.css";
import "../../css/confirm.css";
import moment from "moment";

class Event202304_uma_gamecode_show extends Component {
  state = {};
  componentDidMount = () => {
    const { loginId, history } = this.props;

    if (loginId === null || loginId === undefined || loginId === "") {
      history.push("/login");
    } else {
      this._getCode();
    }
  };
  componentWillUnmount = () => {};

  UNSAFE_componentWillReceiveProps = (nextProps, nextState) => {
    //console.log(this.props.location.pathname)
    //console.log(nextProps.location)
    return (
      this.props.childProps.addrIdx !== nextProps.childProps.addrIdx ||
      this.props.childProps.addrOrderCode !== nextProps.childProps.addrOrderCode
    );
    // return true;
  };
  componentWillReceiveProps = (nextProps) => {
    ////console.log(nextProps)
    console.log(
      this.props.childProps.addrOrderCode,
      nextProps.childProps.addrOrderCode
    );
    console.log(this.props.childProps.addrIdx, nextProps.childProps.addrIdx);

    if (
      this.props.childProps.addrIdx !== nextProps.childProps.addrIdx ||
      this.props.childProps.addrOrderCode !== nextProps.childProps.addrOrderCode
    ) {
      this._getCode();
    }
  };

  _onClose = () => {
    const { setEventIdx } = this.props;
    setEventIdx(0);
  };
  _getCode = async () => {
    const { loginId, pkg, apiUrl, history } = this.props;
    const orderCode = this.props.childProps.orderCode;
    const at = localStorage.getItem("at");

    if (loginId === null || loginId === undefined || loginId === "") {
    } else {
      const result = await axios
        .post(
          apiUrl + "/event_uma_gamecode_address",
          {
            params: {
              userid: loginId,
              pkg: pkg,
              orderCode: orderCode,
            },
          },
          {
            headers: {
              Authorization: "bearer " + at,
            },
          }
        )
        .catch((error) => {
          console.error(error.response.status);
          if (error.response.status === 403) {
            //console.log('refresh....token...')
            this._refreshToken();
          } else if (error.response.status === 400) {
            history.push("/login");
          }
        });

      if (result) {
        const intReturn = result.data[0].intReturn;
        const codeList = result.data[0].listData;
        if (intReturn === 0) {
          this.setState({
            codeList,
          });
        }
      }
    }
  };
  _refreshToken = async () => {
    const { gotoPage } = this.state;
    const { history, apiUrl, setLoginId, setAuthId, loginId } = this.props;
    const rt = localStorage.getItem("rt");

    if (rt === "" || rt === undefined || rt === null) {
      history.push("/login");
      return false;
    }

    const { data } = await axios.post(apiUrl + "/refreshToken", {
      params: {
        rt: rt,
        userid: loginId,
      },
    });

    if (data[0].intReturn === 0) {
      //console.log(data[0].at)
      localStorage.setItem("at", data[0].at);
      this._getCode();
    } else {
      this.setCookie("account", "");

      setLoginId("");
      setAuthId("");

      setTimeout(() => {
        history.push("/login_ugc");
      }, 500);
    }
  };
  _openAddress = () => {
    const { openAddress, orderCode, recall } = this.props.childProps;
    const today = moment(new Date()).format("YYYY-MM-DD HH:mm:ss");
    console.log(today);
    if (today >= "2023-05-15 00:00:00" && today <= "2023-06-18 23:59:59") {
      if (recall === "N") {
        openAddress(orderCode);
      }
    } else {
      alert("리콜 신청기간이 종료 되었습니다.");
    }
  };
  _renderItem = () => {
    const { codeList } = this.state;
    const { recall } = this.props.childProps;

    const list = codeList.map((item) => {
      return (
        <li>
          <a style={{ fontSize: 13 }}>
            {item.address} {item.addressDetail}
          </a>

          {recall === "N" ? (
            <a
              style={{ cursor: "pointer" }}
              onClick={this._openAddress}
              className="code_copy"
            >
              <i className="ico_copy"></i>주소변경
            </a>
          ) : null}

          {/* <a style={{ cursor: "pointer" }}>{item.gameCode}</a>
          <a
            style={{ cursor: "pointer" }}
            onClick={() => this._copy(item.gameCode)}
            className="code_copy"
          >
            <i className="ico_copy"></i>시리얼 코드 복사하기
          </a> */}
        </li>
        // <tr key={item.orderCode}>
        //   <td>{item.orderCode}</td>
        //   <td>{item.goodCount}</td>
        //   <td>
        //     {item.gameCode}{" "}
        //     <span
        //       style={{ color: "#fff" }}
        //       onClick={() => this._copy(item.gameCode)}
        //     >
        //       copy
        //     </span>
        //   </td>
        // </tr>
      );
    });

    return list;
  };
  _copy = (gameCode) => {
    if (navigator.clipboard) {
      // (IE는 사용 못하고, 크롬은 66버전 이상일때 사용 가능합니다.)
      navigator.clipboard
        .writeText(gameCode)
        .then(() => {
          alert("클립보드에 복사되었습니다.");
        })
        .catch(() => {
          alert("복사를 다시 시도해주세요.");
        });
    } else {
      // 흐름 2.
      if (!document.queryCommandSupported("copy")) {
        return alert("복사하기가 지원되지 않는 브라우저입니다.");
      }

      // 흐름 3.
      const textarea = document.createElement("textarea");
      textarea.value = gameCode;
      textarea.style.top = 0;
      textarea.style.left = 0;
      textarea.style.position = "fixed";

      // 흐름 4.
      document.body.appendChild(textarea);
      // focus() -> 사파리 브라우저 서포팅
      textarea.focus();
      // select() -> 사용자가 입력한 내용을 영역을 설정할 때 필요
      textarea.select();
      // 흐름 5.
      document.execCommand("copy");
      // 흐름 6.
      document.body.removeChild(textarea);
      alert("클립보드에 복사되었습니다.");
    }
  };
  render() {
    const { imgUrl } = this.props;
    const { codeList, orderCode, showCode } = this.state;

    return (
      <Fragment>
        <ul>{codeList ? this._renderItem() : null}</ul>
      </Fragment>
    );
  }
}

export default shopContext(withRouter(Event202304_uma_gamecode_show));
